// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/store";
import ElementUI from "element-ui";
import utils from "../static/js/utils";
import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui";
import api from "./api/api";
import "../static/icon/iconfont.css";
import "../static/icon2/iconfont.css";
import "../static/icon3/iconfont.css";
import "../static/css/clf.less";
import "../static/css/template.css";
import ElTreeSelect from "el-tree-select";
import VueQuillEditor from "vue-quill-editor";
// require styles 引入样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VideoPlayer from "vue-video-player";
import VueClipboard from "vue-clipboard2";
import globalVariable from "./components/question/globalVariable";
//版本迭代提醒
import "../static/js/versionControl.js";
//自定义指令
import Permission from "../static/js/permission.js";
Vue.use(Permission);
Vue.prototype.commonsVariable = globalVariable;
Vue.use(VueClipboard);
Vue.use(VideoPlayer);
Vue.use(VueQuillEditor);
Vue.use(ElementUI, { size: "small" });
Vue.use(ElementUI);
Vue.use(ElTreeSelect);
Vue.use(utils);

Vue.config.productionTip = false;
require("../static/css/style.css");
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
// Vue.prototype.user=JSON.parse(localStorage.getItem("user"))
Vue.prototype.$message = Message;
Vue.prototype.api = api;
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App,
    api
  },
  template: "<App/>",
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js